import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from "@angular/router";

import { RouteConfig } from "./router-config.model";

@Injectable({ providedIn: "root" })
export class ObgRouteReuseStrategy extends RouteReuseStrategy {
	shouldDetach(_route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	store(_route: ActivatedRouteSnapshot, _detachedTree: DetachedRouteHandle) {
		// noop
	}

	shouldAttach(_route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		return null;
	}

	shouldReuseRoute(newRoute?: ActivatedRouteSnapshot, currentRoute?: ActivatedRouteSnapshot): boolean {
		// If either route is not provided, return false (default to NOT reusing)
		if (!newRoute || !currentRoute) {
			return false;
		}

		const currentConfig = currentRoute.routeConfig as RouteConfig;
		const newConfig = newRoute.routeConfig as RouteConfig;

		// If both route configs are missing, reuse
		if (!currentConfig && !newConfig) {
			return true;
		}

		// If only one config is missing, don't reuse
		if (!currentConfig || !newConfig) {
			return false;
		}

		// Final decision based on component sharing settings
		return newConfig.disableComponentSharing !== true && newConfig.component === currentConfig.component;
	}
}
